import logo from './logo.svg';
import './App.css';
import { NavBar } from './components/NavBar';
import { Banner } from './components/Banner';
import { Abouts } from './components/Abouts';
import { FutureProjects } from './components/FutureProjects';
import { AwardsAndRecognitions } from './components/AwardsAndRecognitions';
import { Sponsors } from './components/Sponsors';
import { Footer } from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css'

function App() {
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Abouts />
      <FutureProjects />
      <AwardsAndRecognitions />
      <Sponsors />
      <Footer />
    </div>
  );
}

export default App;
